<template>
  <section class="cardFooter" :class="{ ['cardFooter--disabled']: disabled }">
    <section class="cardFooter-title">
      <h3>{{ title }}</h3>
      <!-- <h5 @click="$emit('onAction', subtitleAction)">
        {{ subtitle }}<img src="image/icon_info.svg" />
      </h5> -->
    </section>
    <section class="cardFooter-middle">
      <section v-if="moneyExist && aboutExist" class="cardFooter-money">
        <animated-number class="cardFooter-money_value" :number="money" />
        <span class="cardFooter-money_unit">円</span>
      </section>
    </section>
    <section
      v-if="!isMobile || (isMobile && !aboutExist)"
      class="cardFooter-right"
    >
      <section v-if="moneyExist && !aboutExist" class="cardFooter-money">
        <animated-number class="cardFooter-money_value" :number="money" />
        <span class="cardFooter-money_unit">円</span>
      </section>
      <section v-if="aboutExist" class="cardFooter-about">
        <h5>（ご参考）月額換算</h5>
        <section class="cardFooter-about_amount">
          <span>約</span>
          <animated-number :number="about" />
          <span>円</span>
        </section>
      </section>
    </section>
    <section v-if="isMobile && aboutExist" class="cardFooter-right--sp">
      <section v-if="moneyExist && !aboutExist" class="cardFooter-money">
        <animated-number class="cardFooter-money_value" :number="money" />
        <span class="cardFooter-money_unit">円</span>
      </section>
      <section v-if="aboutExist" class="cardFooter-about">
        <h5>（ご参考）月額換算</h5>
        <section class="cardFooter-about_amount">
          <span>約</span>
          <animated-number :number="about" />
          <span>円</span>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'CardFooter',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    about: {
      type: Number,
      default: undefined,
    },
    money: {
      type: Number,
      default: undefined,
    },
    subtitleAction: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.common.isMobile,
    }),
    moneyExist() {
      return this.money !== undefined;
    },
    aboutExist() {
      return this.about !== undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
.cardFooter {
  display: flex;
  padding: 15px 40px;
  justify-content: space-between;
  align-items: flex-end;
  &--disabled {
    & .cardFooter {
      &-title {
        & h3 {
          color: #ccc;
        }
        & h5 {
          color: #ccc;
        }
      }
      &-money {
        &_value {
          color: #ccc;
        }
        &_unit {
          color: #ccc;
        }
      }
      &-about {
        h5 {
          color: #ccc;
        }
        &_amount {
          & > span {
            &:first-child {
              color: #ccc;
            }
            &:nth-child(2) {
              color: #ccc;
            }
            &:last-child {
              color: #ccc;
            }
          }
        }
      }
    }
  }
  &-title {
    width: 200px;
    margin-right: 40px;
    align-self: flex-start;
    & h3 {
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
      margin-bottom: 0;
    }
    & h5 {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: 1;
      text-align: left;
      color: #999;
      display: flex;
      cursor: pointer;
      img {
        opacity: 0.6;
        vertical-align: text-top;
      }
    }
  }
  &-money {
    &_value {
      font-size: 30px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: right;
      color: #CC0000;
    }
    &_unit {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: right;
      color: #333;
      margin-left: 5px;
    }
  }
  &-about {
    text-align: right;
    h5 {
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: left;
      color: #333;
      margin-bottom: 10px;
    }
    &_amount {
      & > span {
        &:first-child {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.9;
          letter-spacing: normal;
          text-align: right;
          color: #333;
        }
        &:nth-child(2) {
          font-size: 30px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.6;
          letter-spacing: normal;
          text-align: right;
          color: #CC0000;
          height: 45px;
          margin-right: 10px;
        }
        &:last-child {
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.9;
          letter-spacing: normal;
          text-align: right;
          color: #333;
        }
      }
    }
  }
  // mobile
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    padding: 12px;
    &-title {
      margin-right: 0;
      width:180px;
      h3 {
        font-size: 14px;
      }
      h5 {
        font-size: 13px;
        display:inline;
      }
    }
    &-right {
      &--sp {
        width: 100%;
        .cardFooter {
          &-about {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 18px;
            h5 {
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
